import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Box } from "@mui/material";
import LandingPage from "./components/LandingPage.tsx";
import Quiz from "./components/Quiz.tsx";
import EmailForm from "./components/EmailForm.tsx";
import VideoJS from "./components/ResultsV2.tsx";
import ResultsV2 from "./components/ResultsV5.tsx";
import { colors, fonts } from "./theme/tokens.ts";
//eslint-disable-next-line
import Player from "video.js/dist/types/player";

export interface QuizAnswer {
  questionId: number;
  answer: number;
}

export interface QuizData {
  answers: { [key: string]: number };
  email: string;
}

const theme = createTheme({
  palette: {
    primary: {
      main: colors.coral,
      dark: colors.coralHover,
      contrastText: "#ffffff",
    },
    text: {
      primary: colors.body,
      secondary: colors.muted,
    },
    background: {
      default: "transparent",
    },
  },
  typography: {
    fontFamily: fonts.body,
  },
});

type AppState = "landing" | "quiz" | "email";

function App() {
  const [currentState, setCurrentState] = useState<AppState>("landing");
  // const [quizAnswers, setQuizAnswers] = useState<QuizAnswer[]>([]);
  const [quizData, setQuizData] = useState<QuizData>({
    answers: {},
    email: "",
  });

  const handleStartQuiz = () => {
    setCurrentState("quiz");
  };

  const handleQuizComplete = (answers: { [key: string]: number }) => {
    setQuizData((prev) => ({ ...prev, answers }));
    setCurrentState("email");
  };

  const handleEmailSubmit = (email: string) => {
    setQuizData((prev) => ({ ...prev, email }));
  };

  const renderCurrentState = () => {
    switch (currentState) {
    case "landing":
      return <LandingPage onStartQuiz={handleStartQuiz} />;
    case "quiz":
      return <Quiz onComplete={handleQuizComplete} />;
    case "email":
      return (
        <EmailForm onSubmit={handleEmailSubmit} answers={quizData.answers} />
      );
    default:
      return <LandingPage onStartQuiz={handleStartQuiz} />;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route
          path="/"
          element={
            <Box
              sx={{
                backgroundColor: "transparent",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {renderCurrentState()}
            </Box>
          }
        />
        <Route path="results/:encryptedVideos" element={<VideoJS />} />
        <Route path="v2/results/:encryptedVideos" element={<ResultsV2 />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
